var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('a',{class:Object.assign({}, _vm.data.class, ( _obj = {}, _obj[_vm.data.staticClass] = !!_vm.data.staticClass, _obj ), {caption: true}),on:{"click":function($event){return _vm.parent.$router.history.go(-1)}}},[_vm._v(" ← "+_vm._s(_vm.parent.$t("Back"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }